import { cachedFetch } from '@remarkablenet/rcm-utils/cached-fetch'
import { getAntiForgeryToken } from '@remarkablenet/rcm-utils'

const WISHLIST_URL = '/api/wishlist';
const SINGLE_FETCH_ERROR_MESSAGE = 'server error';
const MULTIPLE_FETCH_ERROR_MESSAGE = 'error processing one or more products';
const QUICK_WISHLIST_URL = '/wishlist/quickwishlist';
const cacheBuster = () => new Date().getTime();

export const getQuickwishlistHTML = () => {
    return fetch(`${QUICK_WISHLIST_URL}?c=${cacheBuster()}`, { credentials: 'include', cache: 'no-store' })
        .then((response) => {
            return response.text();
        })
        .catch((err) => {
            return { message: 'server error', err };
        });
};

const processSingleItem = (singleItem, action) => {
    return fetch(`${WISHLIST_URL}/${action}`, {
        headers: {
            RequestVerificationToken: getAntiForgeryToken(),
            Accept: 'application/json',
            'Content-Type': 'application/json'
        },
        method: 'POST',
        credentials: 'include',
        body: JSON.stringify({
            ProductID: singleItem
        })
    })
        .then((res) => {
            return res.json();
        })
        .then((item) => {
            if (!item.success) return { ...singleItem, ...item };
            var cache = sessionStorage.getItem('wishlist'),
                dataCache = [];
            if (cache) dataCache = JSON.parse(cache);
            if (action === 'add') {
                dataCache.push({
                    productId: singleItem
                });
            } else {
                var ind = dataCache.findIndex((x) => x.productId === singleItem);
                dataCache.splice(ind, 1);
            }

            sessionStorage.setItem('wishlist', JSON.stringify(dataCache));
            return item;
        })
        .catch((error) => {
            return { message: SINGLE_FETCH_ERROR_MESSAGE, error };
        });
};

const processMultipleItems = (itemArray, action) => {
    const fetchArray = itemArray.map((singleItem) => {
        return processSingleItem(singleItem, action);
    });

    return Promise.all(fetchArray).catch((error) => {
        return { message: MULTIPLE_FETCH_ERROR_MESSAGE, errorResponse: error };
    });
};

const getCurrentData = (options = { cacheBuster: false }) => {
    return cachedFetch({
        url: `${WISHLIST_URL}`,
        options: {
            request: { credentials: 'include', method: 'GET' },
            cacheBuster: options.cacheBuster,
            seconds: 60
        }
    })
        .then((response) => response.json())
        .then((data) => data)
        .catch((error) => {
            return { message: SINGLE_FETCH_ERROR_MESSAGE, error };
        });
};

// Get wishlist count
export const getWishlistCount = async (opts = { cacheBuster: false }) => {
    const wishlist: any = await getCurrentData(opts);
    return wishlist.length > 9 ? '9+' : wishlist.length;
};

// Add to wishlist
export const addToWishlist = (itemToAdd) => {
    if (Array.isArray(itemToAdd)) return processMultipleItems(itemToAdd, 'add');
    return processSingleItem(itemToAdd, 'add');
};

// Remove from wishlist
export const removeFromWishlist = (itemToRemove) => {
    if (Array.isArray(itemToRemove)) return processMultipleItems(itemToRemove, 'delete');
    return processSingleItem(itemToRemove, 'delete');
};

// Get currenct wishlist
export const getCurrentWishlistData = (opts = { cacheBuster: false }) => {
    return getCurrentData(opts);
};
